<template>
  <div class="breadcrumbs">
    <ol class="breadcrumb">
      <template v-for="(index, breadcrumb) in $route.breadcrumbs">
        <li v-if="(index+1) == $route.breadcrumbs.length" class="active">
          <div class="gsc-wheel-outer">
            <p class="bc-label">
              {{ $index + 1 }}
            </p>
            <div class="gsc-wheel-inner"></div>
          </div>
          <div class="bc-name">
            {{ breadcrumb.name }}
          </div>
        </li>
        <li v-else>
          <a v-link="breadcrumb.url">
            <div class="inactive-div">
              <div class="gsc-wheel-outer bc-inactive">
                <p class="bc-label">
                  {{ $index + 1 }}
                </p>
                <div class="gsc-wheel-inner"></div>
              </div>
              <div class="bc-name">
                {{ breadcrumb.name }}
              </div>
            </div>
          </a>
        </li>
      </template>
    </ol>
    <div v-if="showLink" class="box box-primary">
      <div class="text-center box-body">
        If you need to come back to complete your application later, you can <a href="#" @click="sendEmail()"><strong>click here</strong></a> to send a link to return here to your email!
      </div>
    </div>
    <!-- success modal -->
    <modal v-el:success-modal v-if="successModal">
      <template slot="header">
        <h4 class="modal-title">Success</h4>
      </template>
      <template slot="body">
        Email sent!
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from '../Modal'
export default {
  name: 'Breadcrumbs',
  components: {
    Modal
  },
  data () {
    return {
      linkedObjects: {},
      successModal: false
    }
  },
  computed: {
    showLink () {
      if (window.sessionStorage) {
        let token = window.sessionStorage.getItem('token')
        if (token) return true
      }
      return false
    }
  },
  route: {
    data () {
    }
  },
  ready () {
  },
  methods: {
    sendEmail () {
      this.$http.get(`${this.$route.authType}/sendTokenEmail`, {}).then((response, status, request) => {
        this.successModal = true
        this.$nextTick(function () {
          $(this.$els.successModal).modal()
          $(this.$els.successModal).on('hidden.bs.modal', (e) => {
            this.successModal = false
          })
        })
      })
    },
    logout () {
      this.$http.headers.common.Authorization = false
      window.sessionStorage.removeItem('token')
      this.$root.$route.router.go('/admin/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Breadcrumbs.vue?2733da58